import styled, { css } from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getBodyStyle, getColor, Theme } from 'styles/theme';

interface InitialExpandedState {
  mobile: boolean;
  tablet: boolean;
  desktop: boolean;
}

export const Wrapper = styled.div<{ theme: Theme }>`
  background-color: ${getColor('surfaceWhite')};
  box-shadow: 4px 4px 20px 0px ${getColor('textPrimary')}0D;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (${breakpoint.lgMin}) {
    max-height: 100vh;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 0;  /* Remove scrollbar space */
      background: transparent;  /* Optional: just make scrollbar invisible */
  }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.span<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  position: relative;
  flex: 1;

  &::after {
    content: '';
    display: flex;
    width: 24px;
    height: 24px;
    position: absolute;
    top: 0;
    right: 0;
    background-color: ${getColor('iconPrimary')};
    mask-image: url('/icons/ButtonIcons/Filter.svg');
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  }

  &:hover::after {
    background-color: ${getColor('iconAccentPrimary')};
  }

  &:active::after {
    background-color: ${getColor('iconSecondary')};
  }
`;

const expanded = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const collapsed = css`
  display: none;
  width: 100%;
`;

export const Body = styled.div<{
  $isExpanded?: boolean;
  $initialExpandedState: InitialExpandedState;
}>`
  .dropdown ul {
    z-index: 7;
  }
  
  ${({ $isExpanded }) => {
    if ($isExpanded === undefined) {
      return css<{ $initialExpandedState: InitialExpandedState }>` 
        ${({ $initialExpandedState }) => ($initialExpandedState.mobile ? expanded : collapsed)}
        @media (${breakpoint.mdMin}) {
          ${({ $initialExpandedState }) => ($initialExpandedState.tablet ? expanded : collapsed)}
        }
        @media (${breakpoint.lgMin}) {
          ${({ $initialExpandedState }) => ($initialExpandedState.desktop ? expanded : collapsed)}
        }   
      `;
    }
    return $isExpanded ? expanded : collapsed;
  }}
`;

export const ResultsCount = styled.div<{ theme: Theme }>`
  line-height: 24px;
  letter-spacing: 0.5px;
  ${getBodyStyle('graphikCond', { default: 'default' })}
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;

  .filters-button {
    width: 100%;
  }
`;

export const DisclaimerText = styled.p<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.5px;
  color: ${getColor('textPrimary')};
  margin-top: 8px;
`;
